var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "handle-in-time" },
    [
      _c(
        "div",
        {
          staticClass: "flex-align-center",
          staticStyle: { "margin-bottom": "15px" },
        },
        [
          _c("img", {
            staticClass: "star",
            attrs: {
              src: require("@/assets/imgs/school/monthRecord/star.png"),
              alt: "",
            },
          }),
          _c(
            "div",
            { staticClass: "title title-2", staticStyle: { color: "#304efa" } },
            [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]
          ),
        ]
      ),
      _vm.dataSource.length
        ? _c(
            "div",
            { staticClass: "list" },
            _vm._l(_vm.dataSource, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "list-item flex-between" },
                [
                  _c("div", { staticClass: "flex-center" }, [
                    _c("img", {
                      staticClass: "rank-icon",
                      staticStyle: { "margin-right": "10px" },
                      attrs: {
                        src: require("@/assets/imgs/school/monthRecord/checkMark.png"),
                        alt: "",
                      },
                    }),
                    _c("div", [_vm._v(_vm._s(item.className) + " –")]),
                  ]),
                  _c("div", [_vm._v("班主任：" + _vm._s(item.teacherName))]),
                ]
              )
            }),
            0
          )
        : _c("EmptyData"),
      _c("a-divider", { staticStyle: { margin: "15px 0" } }),
      _vm.dataSource.length
        ? _c("div", { staticClass: "bottom-text" }, [_vm._m(0), _vm._m(1)])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("span", [_vm._v("说明：")]),
      _c("span", [
        _vm._v("处理记录详实、规范，关怀措施针对性强、可作为典型案例推广"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("span", [_vm._v("优秀案例亮点：")]),
      _c("span", [
        _vm._v(
          "① 详细记录学生情绪波动原因 ② 制定个性化关怀方案 ③ 持续跟踪反馈效果"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }